import React from 'react';
import { motion } from 'framer-motion';
interface TestimonialCardProps {
  initials: string;
  rating: number;
  text: string;
  author: string;
  badge?: string;
}
export function TestimonialCard({
  initials,
  rating,
  text,
  author,
  badge
}: TestimonialCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5
  }} className="bg-bg-card border border-border-subtle rounded-xl p-6" data-id="element-243">
      <div className="flex items-start gap-4 mb-4" data-id="element-244">
        <div className="w-12 h-12 rounded-full bg-gold-primary flex items-center justify-center flex-shrink-0" data-id="element-245">
          <span className="text-black font-bold text-base" data-id="element-246">{initials}</span>
        </div>
        <div className="flex-1" data-id="element-247">
          <div className="flex items-center gap-1 mb-2" data-id="element-248">
            {[...Array(rating)].map((_, i) => <span key={i} className="text-text-gold text-sm" data-id="element-249">
                ★
              </span>)}
          </div>
          {badge && <span className="inline-block bg-bg-input text-text-muted rounded-md px-2 py-1 text-xs font-medium mb-2" data-id="element-250">
              {badge}
            </span>}
        </div>
      </div>
      <p className="text-text-secondary italic text-base mb-4 leading-relaxed" data-id="element-251">
        "{text}"
      </p>
      <p className="text-text-primary text-sm font-bold" data-id="element-252">— {author}</p>
    </motion.div>;
}